<template>
  <div class="employe-change-record">
    <el-button
      :type="recordActiveName == 'all' ? 'primary' : ''"
      round
      size="mini"
      @click="recordHandleClick('all')"
      >全部记录</el-button
    >
    <el-button
      v-for="(item, key) in userChangeReviewStatusDic"
      :key="key"
      :type="recordActiveName == key ? 'primary' : ''"
      round
      size="mini"
      @click="recordHandleClick(key)"
      >{{ item }}</el-button
    >

    <div class="change-main">
      <div class="main-top">
        <div class="top-left">
          <el-button @click="inToday">今天</el-button>
          <el-button @click="inYesterday">昨天</el-button>
          <el-button @click="inSevenDays">近7天</el-button>
          <el-date-picker
            align="center"
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            @change="changeDate"
          ></el-date-picker>
          <el-select
            v-model="query.changeType"
            clearable
            placeholder="异动类型"
            @change="getChangeRecordsList"
          >
            <el-option
              v-for="(item, key) in changeType"
              :key="key"
              :label="item"
              :value="key"
            ></el-option>
          </el-select>
        </div>
        <div class="top-right">
          <el-input
            :placeholder="searchText"
            v-model="query.Filter"
            class="input-with-select"
            @keyup.enter.native="getChangeRecordsList"
          >
            <el-select
              v-model="searchText"
              slot="prepend"
              placeholder="请选择"
              @change="changeFilter"
            >
              <el-option label="全文搜索" value="全文搜索"></el-option>
              <el-option
                label="前缀搜索"
                value="按异动记录关键字搜索"
              ></el-option>
              <el-option label="按提交人" value="按提交人搜索"></el-option>
              <el-option label="按审核人" value="按审核人搜索"></el-option>
            </el-select>
            <i
              class="el-icon-search el-input__icon input__suffix"
              slot="suffix"
              @click="getChangeRecordsList"
            ></i>
          </el-input>
        </div>
      </div>
      <el-table
        :data="changeRecordTable"
        @sort-change="changeSort"
        style="width: 100%"
        header-align="center"
      >
        <el-table-column
          type="index"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creator"
          label="提交人"
          width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="creationTime"
          label="提交时间"
          sortable="custom"
          align="center"
          width="150"
        ></el-table-column>
        <el-table-column
          prop="description"
          label="员工异动记录"
          show-overflow-tooltip
          width="400"
        />
        <el-table-column
          prop="changeType"
          label="类型"
          width="70"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="effectiveTime"
          label="生效日期"
          align="center"
          width="150"
        >
          <template slot-scope="scope">{{
            scope.row.effectiveTime | dayFormat
          }}</template>
        </el-table-column>
        <el-table-column
          prop="reviewer"
          label="审核人"
          width="70"
          align="center"
          v-if="recordActiveName != 'Waiting'"
        >
          <template slot-scope="scope">{{
            scope.row.reviewer | nullValue
          }}</template>
        </el-table-column>
        <el-table-column
          prop="reviewTime"
          label="审核时间"
          sortable="custom"
          align="center"
          width="150"
          v-if="recordActiveName != 'Waiting'"
        >
          <template slot-scope="scope">{{
            scope.row.reviewTime | nullValue
          }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="90"
          v-if="recordActiveName == 'Waiting'"
          align="center"
        >
          <template slot-scope="scope">
            <div class="table-operation">
              <el-button
                @click.native.prevent="pass(scope.row.id)"
                type="text"
                
                v-if="scope.row.canReview"
                >审核</el-button
              >
              <el-button
                @click.native.prevent="refuse(scope.row.id)"
                type="text"
                
                v-if="scope.row.canReview"
                >驳回</el-button
              >
              <span v-else>—</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="more"
          label="驳回原因"
          show-overflow-tooltip
          align="center"
          v-if="recordActiveName == 'Refuse'"
        >
          <template slot-scope="scope">{{
            scope.row.refusedReason | nullValue
          }}</template>
        </el-table-column>
        <el-table-column
          prop="more"
          label="备注"
          align="center"
          show-overflow-tooltip
          v-else
        >
          <template slot-scope="scope">{{
            scope.row.more | nullValue
          }}</template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="90"
          v-if="recordActiveName == 'Refuse'"
          align="center"
        >
          <template slot-scope="scope">
            <div class="table-operation">
              <el-button
                @click.native.prevent="cancel(scope.row.id)"
                type="text"
                
                v-if="scope.row.canCancel"
                >撤回</el-button
              >
              <span v-else>—</span>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="@/assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !changeRecordTable.length">
            列表为空
          </div>
        </template>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageIndex"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="query.maxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-dialog
      title="驳回提示"
      :visible.sync="isRejectShow"
      width="550px"
      custom-class="employe-dialog"
      @close="handleClose('rejectForm')"
    >
      <el-form
        :model="rejectForm"
        label-position="left"
        label-width="4rem"
        ref="rejectForm"
        :rules="rejectRules"
      >
        <el-form-item label="驳回原因" prop="reason" class="auto-height">
          <el-input
            type="textarea"
            v-model="rejectForm.reason"
            maxlength="200"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isRejectShow = false">取消</el-button>
        <el-button type="primary" @click="submitReject('rejectForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getChangeRecords,
  changeRecordsReview,
  changeRecordsCancel,
} from "@/http/api/employe";
import { dateFormat } from "@/common/filters";
export default {
  data() {
    return {
      id: this.$route.params.id,
      searchText: "全文搜索",
      refuseIdRecordId: "",
      recordActiveName: "all",
      select: "请输入提交人姓名",
      dateRange: [
        new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
        new Date(),
      ],
      changeType: this.$store.getters.enumMetadata.UserChangeType,
      userChangeReviewStatusDic: this.$store.getters.enumMetadata.UserChangeReviewStatus,
      changeRecordTable: [],
      changeRecordInfo: {},
      query: {
        userId: this.$route.params.id,
        filter: "",
        startTime: null,
        endTime: null,
        changeType: null,
        reviewStatus: null,
        status: null,
        timeCondition: "CreationTime",
        maxResultCount: 30,
        skipCount: 0,
      },
      rejectForm: {
        reason: "",
      }, // 驳回表单
      rejectRules: {
        reason: [
          { required: true, message: "请输入驳回原因", trigger: "blur" },
        ],
      }, // 驳回规则
      isRejectShow: false,
      totalCount: 0,
      pageIndex: 1,
      isLoading: true,
    };
  },
  mounted() {
    this.getChangeRecordsList();
    // document.querySelectorAll(".el-tabs__active-bar")[1].style.width = "28px";
  },
  methods: {
    changeFilter(val) {
      //console.log(val, 111111);
      if (val == "全文搜索") {
        this.query.Condition = "";
      } else if (val == "按异动记录关键字搜索") {
        this.query.Condition = "Description";
      } else if (val == "按提交人搜索") {
        this.query.Condition = "Creator";
      } else if (val == "按审核人搜索") {
        this.query.Condition = "Reviewer";
      }
    },
    changeDate(val) {
      //console.log(val, this.dateRange);
      if (this.dateRange) {
        this.query.startTime = this.dateRange[0];
        this.query.endTime = this.dateRange[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      this.getChangeRecordsList();
    },
    // 关闭岗位窗口对调
    handleClose(formName) {
      this.$refs[formName].resetFields();
    },
    // 驳回按钮
    refuse(id) {
      this.refuseIdRecordId = id;
      this.isRejectShow = true;
    },
    // 驳回确认回调
    submitReject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            reviewStatus: "refuse",
            refusedReason: this.rejectForm.reason,
          };
          changeRecordsReview(this.refuseIdRecordId, data).then((res) => {
            if (res) {
              this.$message.success({ message: "驳回成功", showClose: true });
            }            
            this.getChangeRecordsList();
          });
          this.isRejectShow = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 今天
    inToday() {
      let startTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime()
      );
      let endTime = new Date();

      this.dateRange = [startTime, endTime];
      this.getChangeRecordsList();
    },
    // 昨天
    inYesterday() {
      let startTime = new Date(
        new Date().setHours(0, 0, 0, 0) - 24 * 60 * 60 * 1000 - 1000
      );
      let endTime = new Date(new Date().setHours(0, 0, 0, 0) - 1);
      this.dateRange = [startTime, endTime];
      this.getChangeRecordsList();
    },
    // 七天内
    inSevenDays() {
      let startTime = new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 7);
      let endTime = new Date();
      this.dateRange = [startTime, endTime];
      this.getChangeRecordsList();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.query.skipCount = (val - 1) * this.query.maxResultCount;
      this.getChangeRecordsList();
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.query.maxResultCount = val;
      this.getChangeRecordsList();
    },
    // tab切换
    recordHandleClick(val) {
      this.recordActiveName = val
      this.query.reviewStatus = val == "all" ? null : val;
      //console.log(this.query.reviewStatus, 2222, val);
      this.pageIndex = 1;
      this.getChangeRecordsList();
    },
    // 时间排序
    changeSort(val) {
      //console.log(val, 1111111111);
      this.query.sorting = val.order == "descending" ? `${val.prop} desc` :(val.order == "ascending"?`${val.prop} asc`:'');
      this.getChangeRecordsList();
    },
    // 获取异动记录
    getChangeRecordsList() {
      this.isLoading = true;
      this.changeRecordTable = [];
      if (this.dateRange) {
        this.query.startTime = this.dateRange[0];
        this.query.endTime = this.dateRange[1];
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      if (this.query.startTime) {
        this.query.startTime = dateFormat(this.query.startTime);
      }
      if (this.query.endTime) {
        this.query.endTime = dateFormat(this.query.endTime);
      }
      //console.log(this.query, "获取数据前");
      this.query.skipCount = (this.pageIndex - 1) * this.query.maxResultCount;

      getChangeRecords(this.query).then((res) => {
        this.totalCount = res.result.totalCount;
        this.changeRecordTable = res.result.items;
        this.isLoading = false;
      });
    },
    // 审核回调
    pass(id) {
      this.$confirm(`是否通过审核？`, "审核提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          //console.log("确定审核");
          changeRecordsReview(id, {
            reviewStatus: "success",
          }).then((res) => {
            if (res) {
              this.$message.success({ message: "审核通过", showClose: true });
            }
            this.getChangeRecordsList();
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 撤回回调
    cancel(id) {
      this.$confirm(`是否撤回该异动？`, "撤回提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          //console.log("确定撤回");
          changeRecordsCancel(id).then((res) => {
            this.getChangeRecordsList();
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 再次提交
    againChange() {
      this.$confirm(`是否再次提交该异动？`, "再次提交提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          //console.log("确定再次提交");
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.employe-change-record {
  ::v-deep .el-tabs {
    margin-top: -5px;
    .el-tabs__header {
      background-color: transparent;
      border-bottom: 1px solid #ddd;
    }

    .el-tabs__content {
      padding: 0;
    }
  }
  .change-main {
    margin-top: 20px;
    padding: 20px;
    border-radius: $--border-radius-base;
    background: #fff;
    // box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2);

    .main-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      height: 30px;

      .top-left {
        display: flex;
        align-items: center;
        height: 100%;

        .el-button {
          margin: 0;
          border-radius: 0;
          border-right-color: transparent;
          height: 30px;

          &:focus {
            border-right-color: $--color-primary;
          }
        }
        .el-button:first-child{
          border-radius: 4px 0 0 4px;
        }
        .el-input__inner{
           border-radius: 0 4px 4px 0;
        }
        .el-select {
          margin-left: 10px;
          width: 100px;
        }
      }

      .top-right {
        display: flex;
        align-items: center;
        height: 100%;
        width: 320px;
        ::v-deep .input-with-select .el-input__inner {
          width: 200px;
        }
        ::v-deep .el-select .el-input__inner {
          width: 100px;
        }
      }
    }

    .el-table {
      margin-bottom: 15px;
    }
  }

  ::v-deep .employe-dialog {
    .el-dialog__header {
      padding: 25px 25px 20px 25px;
    }

    .el-dialog__body {
      padding: 0 25px;
    }

    .el-dialog__footer {
      padding: 15px 25px 25px 25px;
    }
  }
}
</style>